import React from "react";

const CapsuleCard = ({ gradient, emoji, title, description, isRevealed }) => {
  return (
    <div
      className="tw-h-[230px] tw-w-[240px] md:tw-w-[280px] md:tw-h-[260px]
                 tw-mt-2 md:tw-mt-7 tw-rounded-3xl tw-flex tw-flex-col tw-items-center
                 tw-justify-center tw-px-5 tw-py-5 md:tw-px-6 md:tw-py-6
                 tw-shadow-md tw-shadow-black/30
                 tw-border-[0.5px] tw-border-solid tw-border-white
                 tw-backdrop-blur-sm"
      style={{ background: gradient }}
    >
      <div className="tw-text-5xl md:tw-text-6xl tw-mb-2 md:tw-mb-4 tw-bounce-gentle">
        {emoji}
      </div>

      <h3 className="tw-font-heading tw-text-xl md:tw-text-2xl tw-font-bold tw-text-center tw-mb-1 md:tw-mb-2 tw-text-white">
        {title}
      </h3>

      <p className="tw-text-white/80 tw-text-sm md:tw-text-md tw-text-center">
        {description}
      </p>
      {isRevealed && (
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-white/20 to-transparent animate-pulse" />
      )}
    </div>
  );
};

export default CapsuleCard;
